import { apiService } from '../APIService';

export default {
  clientQuestions(params) {
    return apiService.get('search/client-questions', params);
  },
};
